<template>
  <div class="list-products">
    <ul v-if="products" class="list-group">
      <router-link v-for="product in products" :to="getRouteParams(product)" class="list-group-item">
        {{ product.name }} <span class="badge">{{ product.counter }}</span>
      </router-link>
    </ul>
  </div>
</template>

<script>
  import {mapActions} from 'vuex'

  export default{
    name: 'ListProductsMenu',
    props: ['subcategoryId'],
    data () {
      return {
        products: false
      }
    },
    mounted () {
      this.getProducts()
    },
    methods: {
      getRouteParams (product) {
        return {
          name: 'product',
          params: {
            categorySlug: product.subcategory.category.slug,
            subcategorySlug: product.subcategory.slug,
            productSlug: product.slug,
            productId: product.id
          }
        }
      },
      getProducts () {
        let subcategoryId = this.subcategoryId || 0
        this.$http.get('products?sort=name&with=counter&subcategory_id=' + subcategoryId)
          .then((response) => {
            this.products = response.data.data
            this.$emit('loaded', 'products_menu')
          }, (response) => {
            console.log('error: Loading products resource from API')
          })
      },
      ...mapActions(['loadProducts'])
    }
  }
</script>


// WEBPACK FOOTER //
// ListProductsMenu.vue?0d2165c1